import React from "react";
import "./HostImageGrid.css";

const HostImageGrid = ({ experienceImages }) => {
  const experienceMedia = experienceImages;
  return (
    <div className="grid-container">
      {experienceMedia.slice(0, 6).map((media, index) => {
        const isVideo =
          media.endsWith(".mp4") ||
          media.endsWith(".mov") ||
          media.endsWith(".webm");
        return (
          <div
            key={index}
            className={`image-wrapper ${index === 0 ? "large-image" : ""}`}
          >
            {isVideo ? (
              <video src={media} className="image" controls playsInline />
            ) : (
              <img
                src={media}
                alt={`Experience ${index + 1}`}
                className="image"
              />
            )}
            {index === 5 && experienceMedia.length > 6 && (
              <div className="overlay">
                <span className="more-text Satoshi">
                  +{experienceMedia.length - 6}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default HostImageGrid;
